import { CompanyUsersScope } from 'mormaii-web-presentation/company-users'
import type { ViewFactory } from 'wdc-cube-solid'

import { registerViews as registerDetailViews } from './detail'
import { registerViews as registerFormViews } from './form'
import { CompanyUsersView } from './v-company-users'

/** A area, o dialogo de cadastro e a ficha de cada usuario. */
export function registerViews(rv: typeof ViewFactory.register) {
    rv(CompanyUsersScope, CompanyUsersView)

    registerFormViews(rv)
    registerDetailViews(rv)
}

export { CompanyUsersView }
